import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=370f13c0&scoped=true&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=370f13c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f13c0",
  null
  
)

export default component.exports